export default "__VITE_ASSET__DuTMNIR9__"